import { type AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { sharedStorageService } from 'services';
import {
  type SharedStorageFileRequest,
  type SharedStorageFile,
} from 'types/sharedStorage';
import { type ValidationError } from 'types/error';

export const useSharedStorageFile = (
  params: Partial<SharedStorageFileRequest>
) => {
  return useQuery<SharedStorageFile, AxiosError<ValidationError>>({
    queryKey: ['sharedStorageFile', params],
    queryFn: () => sharedStorageService.getFile(params),
    enabled: Boolean(params.id && params.fileId),
  });
};
